import axios from 'axios'

export async function isApiReachable(apiHost: string, timeoutMs: number): Promise<boolean> {
  try {
    await axios({
      method: 'get',
      url: `${apiHost}/app-status`,
      timeout: timeoutMs,
    })
    return true
  } catch {
    return false
  }
}
